import React from 'react'
import LayoutContentRight from '../../core/components/LayoutContentRight'
import FooterContainer from '../../core/containers/FooterContainer'
import LayoutWithAdminDrawerContainer from '../../core/containers/LayoutWithAdminDrawerContainer'
import AdminHeaderContainer from '../containers/AdminHeaderContainer'
import RestaurantAdminContentContainer from '../containers/RestaurantAdminContentContainer'

const RestaurantAdmin = () => (
  <LayoutWithAdminDrawerContainer
    renderContentRight={() => (
      <LayoutContentRight
        renderFooter={() => <FooterContainer />}
        renderHeader={() => <AdminHeaderContainer />}
        renderMain={() => <RestaurantAdminContentContainer />}
      />
    )}
  />
)

export default RestaurantAdmin
